import { classNames } from "@opensea/ui-kit"

export const TRANSFER_FLOW_FORM_ITEM_CLASSNAMES = {
  item: classNames("grow first:pl-0"),
  actions: classNames("flex justify-end gap-3"),
}
